export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  tabStyle: {
    paddingLeft: "1em",
    paddingRight: "1em",
    marginBottom: "1em"
  },
  titleStyle: {
    textTransform: "capitalize"
  },
  booleanContainerStyle: {
    textTransform: "capitalize",
    float: "left",
    width: "20%"
  },
  imageStyle: {
    float: "left",
    marginRight: "2%",
    paddingLeft: "1em"
  },
  booleanFieldStyle: {
    padding: "1em",
    width: "20em",
    marginTop: "1.5em"
  },
  clearFloatContainer: {
    clear: "both"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/MarketingPartners/style.js